/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Enum of application feature area identifiers used in service requests.
 * Each value corresponds to a logical feature or screen that initiates
 * backend API calls.
 * @see https://github.com/tivocorp/unity-client-doc/blob/main/doc/api-policies/common-headers.md
 */
export enum ApplicationFeatureArea {
  HOME = "Home",
  MY_SHOWS = "MyShows",
  GUIDE = "Guide",
  SHOWS_AND_MOVIES = "ShowsAndMovies",
  TV_SHOWS = "TV Shows",
  MOVIES = "Movies",
  SPORTS = "Sports",
  KIDS = "Kids",
  SETTINGS = "Settings",
  LOGIN = "Login",
  VOD = "Vod",
  SMART_SEARCH = "SmartSearch",
  ALL = "all"
}
